export const classNamePrefix = 'access-builder-request-info'
